import { render, staticRenderFns } from "./petition.vue?vue&type=template&id=7f5007eb"
import script from "./petition.vue?vue&type=script&lang=js"
export * from "./petition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports